import UsersTable from "../components/Users/UsersTable";
import UserForm from "../components/Users/UserForm"; // create this if not already
import React, { useEffect, useState } from "react";
const UsersPage = () => {
  const [view, setView] = useState("table"); // 'table' or 'form'
  const [editingUser, setEditingUser] = useState(null); // for edit functionality

  const handleAddNew = () => {
    setEditingUser(null);
    setView("form");
  };

  const handleEdit = (user) => {
    setEditingUser(user);
    setView("form");
  };

  const handleFormClose = () => {
    setView("table");
  };
  return (
    <div className="p-0">
      {view === "table" ? (
        <UsersTable onAddNew={handleAddNew} onEdit={handleEdit} />
      ) : (
        <UserForm user={editingUser} onClose={handleFormClose} />
      )}
    </div>
  );
};

export default UsersPage;
